const hasFiles = document =>
  Boolean(document.files?.length || document.fileDownloadLink || document.originalFilename);

export const isFundingDocumentSatisfied = document => {
  const state = document.state || document.status || 'missing';
  return document.reviewRequired === false
    ? state === 'valid' || hasFiles(document)
    : state === 'valid';
};

export const hasBlockingFundingDocuments = documents =>
  documents.some(
    document =>
      (document.required || (document.reviewRequired !== false && hasFiles(document))) &&
      !isFundingDocumentSatisfied(document),
  );

export const getFundingDocumentsCompletion = (
  documents,
  { pending = false, error = false } = {},
) => {
  if (pending) return null;
  if (error) {
    return { state: 'unavailable', description: 'État des documents administratifs indisponible.' };
  }

  const counted = documents.filter(document => document.counted !== false);
  if (!counted.length) {
    return { state: 'empty', description: 'Aucun document administratif requis.' };
  }

  const states = counted.map(document => document.state || document.status || 'missing');
  const count = states.filter(state => state === 'valid').length;
  const underReview = states.filter(state => state === 'under_review').length;
  const incorrect = states.filter(state => state === 'incorrect').length;
  const missing = states.length - count - underReview - incorrect;
  const description = [
    `${count} pièce${count > 1 ? 's' : ''} validée${count > 1 ? 's' : ''} sur ${states.length}.`,
    underReview > 0 && `${underReview} en attente de validation.`,
    incorrect > 0 && `${incorrect} à corriger.`,
    missing > 0 && `${missing} à fournir.`,
  ]
    .filter(Boolean)
    .join(' ');

  return {
    count,
    total: states.length,
    state: count === states.length ? 'complete' : 'pending',
    description,
  };
};
